{
  "MOBILE_STRUCTURE_NOT_SAVED_DUE_TO_CORRUPTION": {
    "errorCode": 21056,
    "desc": "mobile structure was not saved with site due to a corruption in site structure - missing header, footer or pages container",
    "severity": "fatal"
  },
  "SAVE_FAILED_DUE_TO_PRE_SAVE_OPERATION": {
    "errorCode": 55021,
    "severity": "fatal",
    "params": {
      "p1": "stack"
    }
  },
  "SAVE_DOCUMENT_FAILED_ON_SERVER": {
    "errorCode": 55666,
    "severity": "fatal",
    "desc": "Save document failed due to a server error",
    "params": {
      "p1": "serverErrorCode",
      "p2": "origin",
      "p3": "errorType"
    }
  },
  "AUTOSAVE_RESTORE_FAILED": {
    "errorCode": 55023,
    "severity": "error",
    "desc": "Failed to apply autosave diffs",
    "params": {
      "p1": "errorMsg",
      "p2": "op",
      "p3": "path",
      "p4": "value"
    }
  },
  "AUTOSAVE_FAILED_DUE_TO_PRE_SAVE_OPERATION": {
    "errorCode": 55024,
    "severity": "error",
    "params": {
      "p1": "stack"
    }
  },
  "PASSWORD_PROTECTION_HASH_GENERATION_FAILED": {
    "errorCode": 55025,
    "severity": "error",
    "params": {
      "p1": "serverErrorCode",
      "p2": "errorDescription"
    }
  },
  "SYNC_DELETED_ITEMS_AFTER_SAVE_FAILED": {
    "errorCode": 55026,
    "severity": "error",
    "params": {
      "p1": "errorType",
      "p2": "itemId",
      "p3": "pagesIds"
    }
  },
  "MOBILE_STRUCTURE_MANDATORY_ELEMENT_MISSING": {
    "errorCode": 55027,
    "severity": "error",
    "params": {
      "p1": "missingComponents",
      "p2": "stack"
    }
  },
  "DIRECT_PAGES_DATA_ACCESS_IN_GSD": {
    "errorCode": 55028,
    "severity": "warning",
    "params": {
      "p1": "path",
      "p2": "stack"
    }
  },
  "ADD_COMPONENT_WITH_CUSTOM_STYLE_ID": {
    "errorCode": 55778,
    "sampleRatio": 10,
    "severity": "error",
    "params": {
      "p1": "styleId",
      "p2": "compType",
      "p3": "existingStyle"
    }
  },
  "COMPONENT_WITHOUT_STYLES_AND_SKINS": {
    "errorCode": 55779,
    "severity": "error",
    "params": {
      "p1": "componentType",
      "p2": "pageId"
    }
  },
  "COMPONENT_WITHOUT_DEFAULT_STYLE": {
    "errorCode": 55780,
    "severity": "error",
    "params": {
      "p1": "componentType",
      "p2": "pageId"
    }
  },
  "COMPONENT_WITH_STYLES_IN_BREAKPOINTS": {
    "errorCode": 55781,
    "severity": "error",
    "params": {
      "p1": "componentType",
      "p2": "styleId",
      "p3": "pagesId"
    }
  },
  "FAILED_TO_SEND_MOBILE_MENU_CONTAINER_CORRUPTION_MSG": {
    "errorName": "FAILED_TO_SEND_MOBILE_MENU_CONTAINER_CORRUPTION_MSG",
    "errorCode": 112003,
    "severity": "error",
    "params": {
      "p1": "statusId",
      "p2": "errorType",
      "p3": "errorMessage"
    }
  },
  "INVALID_SITE_BEFORE_PRESAVE": {
    "errorName": "INVALID_SITE_BEFORE_PRESAVE",
    "errorCode": 55029,
    "severity": "error",
    "params": {
      "p1": "errorCode",
      "p2": "errorType",
      "p3": "errorDescription"
    }
  }
}